// Anexar documento no chat: lê o arquivo no navegador e cria o documento COM ORIGEM na conversa (POST /api/client/documents {originChatId}).
// Mesmos tipos e tetos de pages/Documents.tsx (o servidor é quem decide).
import { api, type Doc } from './api';

const TEXT_MAX = 2 * 1024 * 1024, PDF_MAX = 8 * 1024 * 1024;
export const DOC_ACCEPT = '.txt,.md,.csv,.pdf,text/plain,text/markdown,text/csv,application/pdf';
export const isDocFile = (f: File) => /\.(txt|md|csv|pdf)$/i.test(f.name);

const toBase64 = (f: File) => new Promise<string>((ok, no) => {
  const r = new FileReader();
  r.onload = () => ok(String(r.result).split(',')[1] ?? '');
  r.onerror = () => no(new Error('não foi possível ler o arquivo'));
  r.readAsDataURL(f);
});

export async function uploadDocument(file: File, originChatId: string): Promise<Doc> {
  const pdf = /\.pdf$/i.test(file.name);
  if (file.size > (pdf ? PDF_MAX : TEXT_MAX)) throw new Error(pdf ? 'PDF grande demais (máximo 8 MB)' : 'documento grande demais (máximo 2 MB de texto)');
  const content = pdf ? { dataBase64: await toBase64(file) } : { text: await file.text() };
  return api<Doc>('/api/client/documents', { method: 'POST', body: JSON.stringify({ name: file.name, mime: file.type, originChatId, ...content }) });
}

// Documento anexado antes de a conversa existir: a conversa é criada, a tela navega para ela e a seleção é retomada lá (o chat zera a seleção ao trocar de id).
let stash: Doc | null = null;
export const stashPick = (d: Doc) => { stash = d; };
export const takePick = (): Doc[] => { const d = stash; stash = null; return d ? [d] : []; };
